/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React from 'react';

interface IMetadataLoadingOverlayComponent {
    adHocViewHeight: number
}

export default (props: IMetadataLoadingOverlayComponent) => {

    const { adHocViewHeight } = props;

    return (
        <div className="jr-mOverlay jr-mOverlayLight jr jr-jOverlay" style={{ height: `${adHocViewHeight}px`, position: 'relative' }}>
            <div className="jr-mOverlay-centroid jr">
                <div className="jr-mSpinner jr" />
            </div>
        </div>
    );
}
